import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IFormaPagamentoSefaz } from '@app/modules/forma-pagamento-sefaz/model/forma-pagamento-sefaz.model';
import { FormaPagamentoService } from '@app/modules/forma-pagamento/services';
import { InstituicaoFinanceiraService } from '@app/modules/instituicoes-financeiras/services/instituicao.service';
import { SELECT } from '@app/shared/components';
import { filter, finalize } from 'rxjs/operators';
import {
  CustomValidators,
  FormServiceValidationMessages,
  TokenService
} from 'viggo-sistemas-core-web';
import { Utils } from '../../../../shared/helpers/utils';
import { FormaPagamentoSefazService } from '../../../forma-pagamento-sefaz/services/forma-pagamento-sefaz.service';

@Component({
  selector: 'app-fast-forma-pgmt',
  templateUrl: './fast-forma-pgmt.component.html',
  styleUrls: ['./fast-forma-pgmt.component.scss'],
  providers: [
    FormaPagamentoService,
    FormaPagamentoSefazService,
    InstituicaoFinanceiraService
  ]
})
export class FastFormaPgmtComponent implements OnInit {
  form: UntypedFormGroup;

  loading = false;
  public domainId = '';

  indPagOptions: SELECT[] = [
    { viewValue: 'Pagamento à vista', value: '0' },
    { viewValue: 'Pagamento à prazo', value: '1' }
  ];

  tpIntegraOptions: SELECT[] = [
    {
      viewValue:
        'Pagamento integrado com o sistema de automação da empresa (Ex.: equipamento TEF, Comércio Eletrônico)',
      value: '1'
    },
    {
      viewValue:
        'Pagamento não integrado com o sistema de automação da empresa (Ex.: equipamento POS)',
      value: '2'
    }
  ];

  messageService: FormServiceValidationMessages;
  displayMessage = {};
  constructor(
    protected fb: UntypedFormBuilder,
    protected formaPgmtService: FormaPagamentoService,
    protected instituicaoFinanceira: InstituicaoFinanceiraService,
    protected formaPagtoSefazService: FormaPagamentoSefazService,
    protected snackBar: MatSnackBar,
    protected dialogRef: MatDialogRef<FastFormaPgmtComponent>,
    protected tokenService: TokenService
  ) {
    this.messageService = new FormServiceValidationMessages({});
  }

  ngOnInit(): void {
    this.domainId = this.tokenService.getDomain().id;
    this.form = this.fb.group(
      this.usaFiscal
        ? {
            nome: [
              null,
              [
                Validators.required,
                Validators.maxLength(30),
                CustomValidators.isEmptyValue()
              ]
            ],
            forma_pagamento_sefaz: [
              null,
              [
                Validators.required,
                CustomValidators.typeIs('object'),
                CustomValidators.isEmptyValue()
              ]
            ],
            indicador_operacao: [null, [Validators.required]],
            tipo_integracao: [null],
            outra_forma: [
              null,
              [
                Validators.minLength(3),
                Validators.maxLength(60),
                CustomValidators.isEmptyValue()
              ]
            ],
            instituicao_pagamento: [
              null,
              [
                CustomValidators.typeIs('object'),
                CustomValidators.isEmptyValue()
              ]
            ],
            tem_troco: [false],
            a_prazo: [false]
          }
        : {
            nome: [
              null,
              [
                Validators.required,
                Validators.maxLength(30),
                CustomValidators.isEmptyValue()
              ]
            ],
            tem_troco: [false],
            a_prazo: [false]
          }
    );
    this.validateForm();
    if(this.usaFiscal) this.validarCamposFiscais();
  }

  get usaFiscal() {
    return localStorage.getItem('usaFiscal') === 'true';
  }

  validarCamposFiscais() {
    const {
      forma_pagamento_sefaz,
      outra_forma,
      tipo_integracao,
      instituicao_pagamento
    } = this.form.controls;
    forma_pagamento_sefaz.valueChanges.subscribe(pag => {
      if (
        pag &&
        (pag.codigo === '03' ||
          pag.codigo === '04' ||
          pag.codigo === '10' ||
          pag.codigo === '11' ||
          pag.codigo === '12')
      ) {
        tipo_integracao.setValue('2');
        tipo_integracao.disable();
      } else if (pag && pag.codigo === '99') {
        outra_forma.addValidators(Validators.required);
        outra_forma.markAsDirty();
        tipo_integracao.reset();
        tipo_integracao.enable();
      } else {
        tipo_integracao.reset();
        tipo_integracao.enable();
        outra_forma.removeValidators(Validators.required);
        outra_forma.reset();
        outra_forma.setErrors(null);
        outra_forma.markAsDirty();
      }
    });
    // tipo_integracao.valueChanges.subscribe(pag => {
    //   if (pag && pag === '2') {
    //     instituicao_pagamento.reset();
    //     instituicao_pagamento.setErrors(null);
    //     instituicao_pagamento.markAsDirty();
    //     instituicao_pagamento.removeValidators(Validators.required);
    //     instituicao_pagamento.reset();
    //     instituicao_pagamento.setErrors(null);
    //     instituicao_pagamento.markAsDirty();
    //     instituicao_pagamento.markAsTouched();
    //   } else if (pag && pag === '1') {
    //     instituicao_pagamento.addValidators(Validators.required);
    //     instituicao_pagamento.markAsDirty();
    //     instituicao_pagamento.markAsTouched();
    //   } else {
    //     instituicao_pagamento.removeValidators(Validators.required);
    //     instituicao_pagamento.reset();
    //     instituicao_pagamento.setErrors(null);
    //     instituicao_pagamento.markAsDirty();
    //     instituicao_pagamento.markAsTouched();
    //   }
    // });
    this.validateForm();
  }

  onSubmit() {
    this.loading = true;
    var entity = Utils.trimAttributes({
      domain_id: this.tokenService.getDomain().id,
      ...this.form.value
    });
    const { forma_pagamento_sefaz, instituicao_pagamento } = this.form.value;
    if (this.usaFiscal) {
      entity.a_prazo = entity.indicador_operacao === '1';
      entity.tipo_integracao = this.form.controls.tipo_integracao.disabled
        ? '2'
        : '1';
      if (forma_pagamento_sefaz) {
        entity.forma_pagamento_sefaz_id = forma_pagamento_sefaz.id;
        delete entity.forma_pagamento_sefaz;
      }
      delete entity.instituicao_pagamento;
      entity.instituicao_pagamento_id =
        forma_pagamento_sefaz.codigo !== '01' &&
        forma_pagamento_sefaz.codigo !== '02'
          ? instituicao_pagamento
            ? instituicao_pagamento.id
            : null
          : null;
    }
    if (this.form.valid) {
      this.formaPgmtService
        .insert(entity)
        .pipe(filter(result => !!result))
        .subscribe(
          formPgmt => {
            this.loading = false;
            this.dialogRef.close(formPgmt);
            this.snackBar.open(
              'Forma de pagamento cadastrada com sucesso.',
              'X',
              {
                duration: 2000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: ['msg-success']
              }
            );
          },
          () => {
            this.loading = false;
            this.snackBar.open('Erro ao cadastrar forma de pagamento.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-error']
            });
          }
        );
    }
  }

  pagtoDisplay = (entity: IFormaPagamentoSefaz): string => {
    if (entity) {
      return entity.codigo + ' - ' + entity.descricao;
    }
    return '';
  };

  markAllControlsAsDirty() {
    Object.keys(this.form.controls).forEach(controlKey => {
      controlKey = String(controlKey);
      const control = this.form.get(controlKey);
      if (!control || control.valid) return;
      control.markAsDirty();
    });
  }

  validateForm() {
    this.form.markAllAsTouched();
    this.markAllControlsAsDirty();
    if (!this.form.valid) {
      this.displayMessage = this.messageService.getMessagesForm(this.form);
    }
  }

  /**
   * Verifica se o nome da forma de pagamento já está cadastrado
   */
  public verificarNome(): void {
    const control = this.form.controls.nome;

    if (control.invalid) return;
    this.loading = true;
    const nome = control.value;

    this.formaPgmtService
      .getEntitiesByParams({
        where: { nome, domain_id: this.tokenService.getDomain().id }
      })
      .pipe(
        finalize(() => {
          this.loading = false;
        }))
      .subscribe(formaPagamento => {
        control.setErrors({ repeated: true });
        // this.matSnackBar.open(
        //   `Já existe uma forma de pagamento com o nome ${formaPagamento.nome}`,
        //   'X',
        //   {
        //     duration: 2000,
        //     horizontalPosition: 'right',
        //     verticalPosition: 'top',
        //     panelClass: ['msg-error']
        //   }
        // );
      });
  }
}
